import { gql } from '@apollo/client'

const ACCOUNT_AUDIENCES_FIELDS = `
    audiences {
        external_id
        name
        subtype
        approximate_count_lower
        approximate_count_upper
        retention_days
        supports_lookalike
        usable
        reason
        note
    }
    stages {
        stage
        audience_id
    }
    fetched_at
    complete
    count
`

export const ACCOUNT_AUDIENCES = gql`
    query AccountAudiences($publisherId: ID!, $campaignId: ID!) {
        accountAudiences(publisher_id: $publisherId, campaign_id: $campaignId) {
            ${ACCOUNT_AUDIENCES_FIELDS}
        }
    }
`

export const REFRESH_ACCOUNT_AUDIENCES = gql`
    mutation RefreshAccountAudiences($publisherId: ID!, $campaignId: ID!) {
        refreshAccountAudiences(publisher_id: $publisherId, campaign_id: $campaignId) {
            ${ACCOUNT_AUDIENCES_FIELDS}
        }
    }
`
